export const REWARDS_PARTNER_ID = "OutlookOwa";
